import { useToken } from '@ori/auth';
import { useServiceUrls } from '@ori/configuration-manager';
import { useEnvironment } from '@ori/environment';
import { ApiClientProvider } from '@ori/global-api-client-react';
import type { ReactElement } from 'react';

interface ApiProviderProps {
  children: ReactElement;
}

export const ApiProvider = ({ children }: ApiProviderProps) => {
  const { tenant } = useEnvironment();
  const { globalApiUrl } = useServiceUrls(['globalApi']);
  const { token } = useToken();

  return (
    <ApiClientProvider
      baseUrl={globalApiUrl}
      tenant={tenant}
      token={token}
    >
      {children}
    </ApiClientProvider>
  );
};
